/**
 * =========================================================================================
 * ATS History component
 * =========================================================================================
 * Error Popup Handler
 *
 */

import React, {useEffect} from 'react';
import * as Icon from "ubs-icons";
import useUAlert from "ubs-framework/v2/UAlert";
import {onLogout} from "../../store/actions";
import {ERROR} from "../../common/string";
import useSocket from "../common/hooks/useSocket";
import {useDispatch, useSelector} from "react-redux";
import {IGNORE_DEFAULT_ALERT} from "../../common/constant";
import { useFieldLabel } from 'ubs-framework/v2/hooks/useCustomFieldConfig';
import { PROFILE_SECTION } from 'ubs-framework/v2/common/constant';

const ATSHistory = React.memo(props => {
    const alert = useUAlert();
    const DISPATCH = useDispatch()
    const getLabel = useFieldLabel();

    const _CC = useSelector(e => e.ats.commentCounter)

    const {off, refresh} = useSocket(res => {
        switch (res.code) {
            case 200: {
                switch (res.event) {
                    case 'logout': {
                        if (res?.data?.forceLogout) return;
                        const isAdmin = res?.data?.isAdmin;
                        let title, description;

                        if (res?.data?.type === 'resetPassword' || res?.data?.type === 'changePassword') {
                            title = isAdmin ? 'Change Password' : 'Logout';
                            description = isAdmin ? `Your Account's Password has been changed by admin.<br/>Please login again.` : '';
                        } else if (res?.data?.type === 'changeEmail') {
                            title = isAdmin ? `Change ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')}` : 'Logout';
                            description = isAdmin ? `Your Account's ${getLabel(PROFILE_SECTION.emergencyContact, 'email', 'Email')} has been changed by admin.<br/>Please login again.` : '';
                        }
                        alert.show({
                            title,
                            description,
                            icon: isAdmin ? <span className="u_icon u_red-bgicon u_m-auto"><Icon.Warning fill="#FF6961" size={40}/></span> : null,
                            close: 'Logout',
                            onClose: () => onLogout()
                        });
                        break;
                    }
                    case 'hrms|master|globalConversation|unreadMessageFlag': {
                        DISPATCH({type: 'SET_COMMENT_COUNTER', payload: res.data.results})
                        break;
                    }
                    case 'unReadCountMessage': {
                        const counter = _CC?.map(data => {
                            if (data.referenceType === res?.data?.referenceType) data = res.data
                            return data;
                        })
                        DISPATCH({type: 'SET_COMMENT_COUNTER', payload: counter})
                        break;
                    }
                    default:
                        return true;
                }
                break;
            }
            case 400: {
                switch (res.event) {
                    case 'authenticate': {
                        if (res?.data?.isCompanyMFA && !res?.data?.isUserMFASetup) {
                            if (res?.error) DISPATCH({type: 'SET_ERROR', payload: {description: res?.data?.error || res?.data?.message, isRedirectAccount: true, type: 'full'}});
                        }
                        break;
                    }
                    default:
                        if(!IGNORE_DEFAULT_ALERT?.includes(res?.event)) alert.show({title: 'Something went wrong.', description: res?.data?.error || res?.data?.message})
                        break;
                }
                break;
            }
            case 403: {
                switch (res.event) {
                    case 'hrms|ipblocking|user|blocked':
                    case 'authenticate':
                    case 'login': {
                        if (res.data.type === 'Login Restriction') DISPATCH({type: 'SET_ERROR', payload: {description: res?.data?.error || res?.data?.message, type: 'full'}});
                        else if (res.data.type === 'productAccessLocked') DISPATCH({type: 'SET_ERROR', payload: {description: data?.data?.type === 'productAccessLocked' ? ERROR.removeProductAccess : ERROR.allowProductAccess, type: 'full'}});
                        else DISPATCH({type: 'SET_ERROR', payload: {description: res?.data?.error || res?.data?.message, type: 'full'}});
                        break;
                    }
                    default:
                        if(!IGNORE_DEFAULT_ALERT?.includes(res?.event)) alert.show({title: 'Something went wrong.', description: res?.data?.error || res?.data?.message})
                        break;
                }
                break;
            }
            case 404: {
                switch (res.event) {
                    default:
                        break;
                }
                break
            }
            case 406: {
                switch (res.event) {
                    case 'authenticate': {
                        DISPATCH({type: 'SET_ERROR', payload: {description: res?.data?.error || res?.data?.message, type: 'full'}});
                        break;
                    }
                    default:
                        break;
                }
                break
            }
            case 405:
            case 409:
            case 412:
            case 500: {
                if (!IGNORE_DEFAULT_ALERT?.includes(res?.event)) alert.show({title: 'Something went wrong.', description: res?.data?.error || res?.data?.message})
                break
            }
            default:
                break;
        }
    })

    useEffect(() => {
        refresh()
        return () => off()
    }, [_CC])

    return (
        <React.Fragment>

        </React.Fragment>
    );
});

export default ATSHistory;
